module.exports = __webpack_public_path__ + "img/IT0000101248324.233dd2e1.png";